import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";


export const getAdminReport = async(param:any )=>{
   const response = await axiosInstance.get(`${API_ENDPOINTS.Reports.GET_ADMIN_REPORT}`,{params:param});
   const rowData = response?.data;    
  //  console.log('rowData',rowData?.data);
   
   const formatedData =  Array.isArray(rowData?.data.AdminReportData ||{})?
   rowData?.data.AdminReportData.map((item:any)=>({
    EmployeeId:item.EmployeeId  ,
    EmployeeName:item.EmployeeName,
    Designation:item.Designation,
    Branch:item.Branch,
    Expenses:item.Expenses,
    Created: item.Created,
    Submited:item.Submited,
    Approved:item.Approved,
    Rejected:item.Rejected,
    Audited:item.Audited,
    Currency:item.Currency, 
   
  })):[]

    console.log('formatedData',formatedData);
    return{formatedData,rowData};
}
